import { render } from "./cpt-chart-candlestick-option.vue?vue&type=template&id=0827df8a"
import script from "./cpt-chart-candlestick-option.vue?vue&type=script&lang=js"
export * from "./cpt-chart-candlestick-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__